import { TFunction } from 'language/translator'
import { isCustomEconomyMetric, ISelectMetric } from 'types/GlobalMetric'

export type TMetricDialogVariant =
  | 'dashboards'
  | 'metrics'
  | 'reports'
  | 'export_tables'

export type Step = 'slices' | 'rollingSum' | 'distribution' | 'variant'

export function getStepMeta(
  step: Step,
  t: TFunction
): { title: string; description: string } {
  const select = t('global', 'select')

  switch (step) {
  case 'variant':
    return {
      title: `${select} ${t('metrics', 'variant', true)}`,
      description: t('metrics', 'variant_helper_text')
    }
  case 'rollingSum':
    return {
      title: `${select} ${t('metrics', 'rolling_sum', true)}`,
      description: t('metrics', 'rolling_sum_helper_text')
    }
  case 'distribution':
    return {
      title: `${select} ${t('metrics', 'distribution', true)}`,
      description: t('metrics', 'distribution_helper_text')
    }
  case 'slices':
    return {
      title: `${select} ${t('entities', 'slice', true)}`,
      description: t('metrics', 'slices_helper_text')
    }
  }
}

export function buildSteps(
  metric: ISelectMetric | null,
  availableSteps: Step[]
): Step[] {
  if (!metric) return []

  return availableSteps.filter((step) => {
    if (step === 'variant') return isCustomEconomyMetric(metric)
    if (step === 'rollingSum') return metric.rolling_sums.length > 0
    if (step === 'distribution') return metric.distributions.length > 0

    return true
  })
}
